import { StatsProps } from 'types/stats';
import { StatsCard } from '../stats-card';

import './stats-card-list.scss';

type StatsCardListProps = {
  statistics: StatsProps[];
};

export const StatsCardList = ({ statistics }: StatsCardListProps) => (
  <section className="stats-card-list">
    {statistics.map((stats, index) => {
      const className = index > 0 ? 'hide-on-mobile' : '';

      return (
        <StatsCard
          key={stats.title}
          title={stats.title}
          value={stats.value}
          icon={stats.icon}
          className={className}
        />
      );
    })}
  </section>
);
